export const termsAndConditions = 'tcs';
